import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';
import { Logger } from '@main/utils/logger';
import type { WarmMergeTransferEventPublisher } from './warm-merge-transfer.usecase';

export class WarmMergeTransferPublisher
  implements WarmMergeTransferEventPublisher
{
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish(): Promise<void> {
    const busIframe = await BusIframe.getIframe();
    const busEvent: BusEvent = {
      type: 'DIALER.MERGE_WARM_TRANSFER',
    };
    this.logger.info('Publisher: Merge Warm trasnfer number', {
      action: 'transferNumber',
    });

    return BusEventsPromisifier.promisifyFireAndForgetEvent({
      target: busIframe,
      event: busEvent,
    });
  }
}
